import biorhythmTypeChange from './actions/biorhythmTypeChange';
import biorhythmTypeDetail from './actions/biorhythmTypeDetail';
import biorhythmTypesList from './actions/biorhythmTypesList';
import getBiorhythmTypes from './getters/getBiorhythmTypes';
import biorhythmTypesUpload from './mutations/biorhythmTypesUpload';

const actions = {
    biorhythmTypeChange,
    biorhythmTypeDetail,
    biorhythmTypesList
};

const mutations = {
    biorhythmTypesUpload
};

const getters = {
    getBiorhythmTypes
};

export default { actions, mutations, getters };
